import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, track } from "../lib/api";
import { Section, Reveal } from "../components/primitives";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";

export default function Shop() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <Seo title="Shop Botanical Superfoods" description="Explore Cultiva Botanics' range of premium botanical wellness and plant-based superfood products — Moringa, Hibiscus, Beetroot, Amla, Turmeric and Makhana." />
      <PageHero chapter="Shop" overline="The Range" title="Botanical superfoods for modern living." subtitle="Thoughtfully selected plant-based ingredients, rooted in nature and India's botanical heritage." />
      <Section className="py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <Link to={`/products/${p.slug}`} onClick={() => track("product_cta_clicks", { slug: p.slug })}
                className="group block bg-white border border-border rounded-md overflow-hidden hover:shadow-xl hover:shadow-botanical/5 transition-all duration-500"
                data-testid={`shop-card-${p.slug}`}>
                <div className="relative aspect-[4/5] overflow-hidden" style={{ background: `${p.color}0d` }}>
                  <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-700" />
                  {p.status === "coming_soon" && <span className="absolute top-4 right-4 text-[10px] uppercase tracking-widest bg-botanical text-ivory px-3 py-1 rounded-full">Coming Soon</span>}
                </div>
                <div className="p-7 border-t border-border">
                  <div className="text-[11px] uppercase tracking-widest" style={{ color: p.color }}>{p.positioning}</div>
                  <h3 className="font-serif text-3xl text-botanical mt-2">{p.name}</h3>
                  <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{p.short_description}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-botanical">Explore Product <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </div>
  );
}
